const ACE_UNCHANGED_PLACEHOLDER = '-'.repeat(120);
const UNCHANGED_FOLD_CLASS_NAME = 'ace-diff-unchanged-fold';

export default function styleUnchangedFolds(editors) {
  const cleanups = editors.map(editor => {
    const updateFoldClasses = () => {
      const foldElements = editor.container.querySelectorAll('.ace_fold');
      foldElements.forEach(element => {
        element.classList.toggle(UNCHANGED_FOLD_CLASS_NAME, element.textContent === ACE_UNCHANGED_PLACEHOLDER);
      });
    };

    editor.renderer.on('afterRender', updateFoldClasses);
    updateFoldClasses();
    editor.renderer.updateFull();

    return () => {
      editor.renderer.off('afterRender', updateFoldClasses);
      editor.container
        .querySelectorAll(`.${UNCHANGED_FOLD_CLASS_NAME}`)
        .forEach(element => element.classList.remove(UNCHANGED_FOLD_CLASS_NAME));
    };
  });

  return () => cleanups.forEach(cleanup => cleanup());
}
